import { CodeNode } from '@lexical/code-core';
import { ListItemNode, ListNode } from '@lexical/list';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ParagraphNode, TextNode } from 'lexical';

import EditorTheme from '../EditorTheme';
import { CustomListItemNode } from '../nodes/CustomListItemNode';
import { CustomListNode } from '../nodes/CustomListNode';
import { exportMap } from '../utils/exportUtils';

export const editorConfig = {
  html: {
    export: exportMap,
  },
  namespace: 'Editor',
  nodes: [
    ParagraphNode,
    TextNode,
    CustomListNode,
    CustomListItemNode,
    {
      replace: ListNode,
      with: (node: ListNode) =>
        new CustomListNode(node.getListType(), node.getStart()),
      withKlass: CustomListNode,
    },
    {
      replace: ListItemNode,
      with: (node: ListItemNode) =>
        new CustomListItemNode(node.__value, node.__checked),
      withKlass: CustomListItemNode,
    },
    HeadingNode,
    QuoteNode,
    CodeNode,
  ],
  onError(error: Error) {
    throw error;
  },
  theme: EditorTheme,
};
